import type { SaveAdapter } from "./SaveAdapter.js";

/**
 * 개발 모드 + 웹 빌드용 SaveAdapter.
 * `VITE_USE_FIREBASE_SAVE=false` 환경변수로 SaveBootstrapper가 단독 어댑터로 사용.
 * 모바일 출시 본 빌드에서는 CapacitorPreferencesSaveAdapter(캐시) + FirestoreSaveAdapter(메인) 조합 사용.
 */
export class LocalStorageSaveAdapter implements SaveAdapter {
  async save(key: string, payload: string): Promise<void> {
    try {
      window.localStorage.setItem(key, payload);
    } catch (error) {
      throw new Error(
        `[LocalStorageSaveAdapter] failed to save key="${key}": ${(error as Error).message}`,
      );
    }
  }

  async load(key: string): Promise<string | null> {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      console.warn(
        `[LocalStorageSaveAdapter] failed to load key="${key}":`,
        (error as Error).message,
      );
      return null;
    }
  }

  async delete(key: string): Promise<void> {
    try {
      window.localStorage.removeItem(key);
    } catch (error) {
      console.warn(
        `[LocalStorageSaveAdapter] failed to delete key="${key}":`,
        (error as Error).message,
      );
    }
  }
}
